@use "../../sass/global/global" as *;

.ux-iws-product-highlight-slider {
    display: block;
    position: relative;
    max-width: 100vw;
    overflow: hidden;

    &__wrapper {
        position: relative;
        width: 100%;
        max-width: 100vw;
        margin-bottom: 40px;

        @media only screen and (min-width: 1024px) {
            margin-bottom: 0;
            display: flex;
        }
    }

    .ux-iws-teaser-product-tile {
        display: block;
    }

    &__faded-surface {
        position: absolute;
        z-index: 10;
        top: 50%;
        transform: translateY(-50%);
        width: 80px;
        opacity: 0;
        height: 102%;
        cursor: pointer;
        transition: opacity 0.5s ease;

        @media only screen and (min-width: 768px) {
            opacity: 1;
        }
    }

    &__faded-surface--left {
        left: 0;
        background: linear-gradient(
            to left,
            rgba(255, 255, 255, 0.02) 0,
            #fff 100%
        );

        @media only screen and (min-width: 1024px) {
            opacity: 0;
        }
    }

    &__faded-surface--right {
        right: 0;
        background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0.02) 0,
            #fff 100%
        );
    }

    &__highlight-wrapper {
        display: none;

        .ux-iws-teaser-product-tile {
            max-width: none;
        }

        .ux-iws-teaser-product-tile__inner {
            height: 100%;
        }

        .ux-iws-teaser-product-tile__image {
            height: 100%;
        }

        @media only screen and (min-width: 1024px) {
            height: calc(100% - 65.5px);
        }

        @media only screen and (min-width: 1440px) {
            height: calc(100% - 70px);
        }

        @media only screen and (min-width: 1800px) {
            height: calc(100% - 70.5px);
        }

        &::before {
            content: "";
            position: absolute;
            height: 110%;
            left: -100%;
            width: 100%;
            background-color: $color-white;
            top: -5%;
        }

        &::after {
            content: "";
            position: absolute;
            height: 15px;
            left: 0;
            right: 0;
            bottom: -15px;
            width: calc(100% - 30px);
            background-color: $color-white;
        }
    }

    &__slider-wrapper {
        width: 100%;
        margin: 0 auto;

        .ux-iws-teaser-product-tile__image {
            height: 100%;
        }

        @media only screen and (min-width: 768px) and (max-width: 1023px) {
            width: 79%;
        }

        @media only screen and (min-width: 1024px) and (max-width: 1300px) {
            max-width: 320px;
        }

        // fixes bug of minimal portion of slide visible on desktop viewports
        @media only screen and (min-width: 1301px) {
            transform: translateX(-1px);
        }
    }

    @media only screen and (max-width: 1023px) {
        .ux-slider-slide {
            margin-top: 0 !important;
        }
    }

    .ux-slider-container {
        overflow: visible;
    }

    .ux-slider-pagination--bottom {
        margin-top: 5px;

        @media only screen and (min-width: 1024px) {
            margin-top: 20px;
        }

        @media only screen and (min-width: 1440px) {
            margin-top: 25px;
        }
    }

    @media only screen and (min-width: 1024px) {
        display: flex;

        .highlight-slide {
            display: none;
        }

        &__wrapper {
            width: $grid-10;
            margin-left: $grid-1;
        }

        &__highlight-wrapper {
            display: flex;
            align-items: stretch;
            position: relative;
            z-index: 2;
            padding-right: 30px;
            width: 66.66%;
            box-sizing: border-box;
        }

        &__slider-wrapper {
            top: 0;
            width: 33.33%;
            z-index: 0;
            margin: 0;
        }

        .ux-slider-container {
            overflow: visible;
        }
    }

    @media only screen and (min-width: 1301px) {
        &__highlight-wrapper {
            width: 50%;
        }

        &__slider-wrapper {
            width: 50%;
        }
    }

    @media only screen and (min-width: 1800px) {
        &__highlight-wrapper {
            width: 40%;
        }

        &__slider-wrapper {
            width: 60%;
        }
    }

    .is-hidden {
        display: none;
    }

    &--no-highlight {
        .ux-iws-product-highlight-slider__wrapper {
            min-height: 100%;
            margin-bottom: 0;
        }
    }

    &--no-highlight .ux-iws-product-highlight-slider__slider-wrapper {
        width: 100%;
        position: relative;
        max-width: 100%;

        @media only screen and (min-width: 768px) and (max-width: 1023px) {
            width: 80%;
        }
    }

    &--no-highlight .ux-iws-product-highlight-slider__faded-surface--left {
        left: 0;
        background: linear-gradient(
            to left,
            rgba(255, 255, 255, 0.02) 0,
            #fff 100%
        );

        @media only screen and (min-width: 1024px) {
            opacity: 1;
        }
    }
}
